module.exports = __webpack_public_path__ + "static/media/rank-2.89aca91c.png";